export default __webpack_public_path__ + "static/picture1-7761d757c481d360d22f564027bdcf47.gif";